var $ = require('jquery');

$(function () {

    function resetModalScrollHeight() {
        var element = $('.extended-content_content-intro-cards__inner__card__modal--parent')[0];
        if ($(window).width() < 992 && element) {
            $(element)
                .css({ height: ($(window).height() + 20) + 'px' });
        } else {
            $(element)
                .css({ height: 'auto' });
        }
    }


    $('.extended-content_content-intro-cards__inner__card__link a.isModal').each(function () {

        var thisLink = $(this);
        $(this).on('click', function () {
            resetModalScrollHeight();

            document.getElementsByTagName('html')[0].setAttribute('class', 'noScroll');

            var modalWrapper = thisLink.closest('.extended-content_content-intro-cards__inner__card')
                .find('.1900-620-modal-wrapper');

            document.getElementsByTagName('html')[0].setAttribute('class', 'noScroll');
            var modalContent = '<div class="modal-content container"><div class="row"><div class="col-md-10 col-sm-12 col-xs-12"><button data-fancybox-close class="fancybox-close-small"></button>' +
                modalWrapper.html() +
                '</div></div></div>';
            $.fancybox.open({
                content: modalContent,
                autoSize: false,
                fitToView: false,
                close: false,
                type: 'html',
                beforeClose: function () {
                    document.getElementsByTagName('html')[0].setAttribute('class', '');
                }
            });
        });
    });

    $(window).on('resize orientationchange', function () {
        resetModalScrollHeight();
    });

});